import SmsMessage, { ISmsMessage } from '@/models/SmsMessage';
import Passenger, { IPassenger } from './Passenger';


export interface IPassengerWithSms extends IPassenger {
    smsMessages: ISmsMessage[];
}

export default class PassengerWithSms extends Passenger implements IPassengerWithSms  {
    smsMessages: ISmsMessage[];
    constructor(options?: IPassengerWithSms | null) {
        super(options);
        this.smsMessages = options?.smsMessages?.map(sms => new SmsMessage(sms)) ?? [];
    }
}